import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'

//import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import Snackbar from '@material-ui/core/Snackbar'
import Fade from '@material-ui/core/Fade'

import { connect } from 'react-redux'

import { handleAddUser } from '../../actions/users'
import t from '../../utils/lang/user'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: '0 0 10px',
    width: '100%'
  },
});

class AddUserDialog extends Component {
  state = {
    firstName: '',
    lastName: '',
    jobTitle: '',
    email: '',
    phone: '',
    newPassword: '',
    repeatPassword: '',
    snackbarOpen: false,
    snackMessage: ''
  }

  /*componentDidMount() {
    const { data } = this.props
  }*/

  handleChangeFirstName = e => {
    const firstName = e.target.value

    this.setState(() => ({
      firstName
    }))
  }

  handleChangeLastName = e => {
    const lastName = e.target.value

    this.setState(() => ({
      lastName
    }))
  }

  handleChangeJobTitle = e => {
    const jobTitle = e.target.value

    this.setState(() => ({
      jobTitle
    }))
  }

  handleChangeEmail = e => {
    const email = e.target.value

    this.setState(() => ({
      email
    }))
  }

  handleChangePhone = e => {
    const phone = e.target.value

    this.setState(() => ({
      phone
    }))
  }

  handleChangeNewPassword = e => {
    const newPassword = e.target.value

    this.setState(() => ({
      newPassword
    }))
  }

  handleChangerepeatPassword = e => {
    const repeatPassword = e.target.value

    this.setState(() => ({
      repeatPassword
    }))
  }

  handleAddUser = e => {
    const { dispatch, accountId, handleClose } = this.props
    const { firstName, lastName, jobTitle, email, phone, newPassword, repeatPassword } = this.state

    const data = {
      accountId,
      firstName,
      lastName,
      jobTitle,
      email,
      phone,
      password: newPassword
    }

    if (email === '') {
      this.setState({ snackMessage: 'E-mail can\'t be empty.' })

    } else if (newPassword === '' || repeatPassword === '') {
      this.setState({ snackMessage: 'Password can\'t be empty.' })

    } else if (newPassword !== repeatPassword) {
      this.setState({ snackMessage: 'Passwords do not match.' })

    } else {
      dispatch(handleAddUser(data))

      this.setState({
        snackMessage: 'User has been added.',
        firstName: '',
        lastName: '',
        jobTitle: '',
        email: '',
        phone: '',
        newPassword: '',
        repeatPassword: ''
      })

      handleClose()
    }

    this.handleOpenSnackbar()
  }

  handleOpenSnackbar = () => {
    this.setState({ snackbarOpen: true })
  }

  handleCloseSnackbar = () => {
    this.setState({ snackbarOpen: false })
  }

  render() {
    const { fullScreen, open, handleClose, classes } = this.props
    const { firstName, lastName, jobTitle, email, phone, newPassword, repeatPassword, snackMessage } = this.state

    const lang = 'en'

    return (
      <div>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">{t[lang].addUser}</DialogTitle>
          <DialogContent>
            <form className={classes.root}>
              <FormControl className={classes.formControl}>
                  <TextField
                    id="firstName"
                    label={t[lang].firstName}
                    value={firstName}
                    onChange={this.handleChangeFirstName}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="lastName"
                    label={t[lang].lastName}
                    value={lastName}
                    onChange={this.handleChangeLastName}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="jobTitle"
                    label={t[lang].jobTitle}
                    value={jobTitle}
                    onChange={this.handleChangeJobTitle}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="email"
                    label={t[lang].email}
                    value={email}
                    type="email"
                    onChange={this.handleChangeEmail}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="phone"
                    label={t[lang].phone}
                    value={phone}
                    type="phone"
                    onChange={this.handleChangePhone}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="newPassword"
                    label={t[lang].newPassword}
                    value={newPassword}
                    type="password"
                    onChange={this.handleChangeNewPassword}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="repeatPassword"
                    label={t[lang].repeatPassword}
                    value={repeatPassword}
                    type="password"
                    onChange={this.handleChangerepeatPassword}
                  />
                </FormControl>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleAddUser} color="primary" autoFocus>
              Add
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={this.state.snackbarOpen}
          onClose={this.handleCloseSnackbar}
          TransitionComponent={Fade}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          variant='success'
          message={<span id="message-id">{snackMessage}</span>}
        />
      </div>
    );
  }
}

AddUserDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

function mapStateToProps ({ authedUser }) {
  return {
    accountId: authedUser.accountId,
  }
}

export default connect(mapStateToProps)(withStyles(styles)(withMobileDialog()(AddUserDialog)))


// WEBPACK FOOTER //
// ./src/components/Users/AddUserDialog.js